<template>
  <div>
    <a-page-header style="width: 105%; margin-left: -20px" title="">
      <template slot="tags">
        <a-breadcrumb>
          <a-breadcrumb-item href="">
            <a-icon type="safety-certificate"/>
            <span>{{ $t('message.txtManagement.title1') }}</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="">
            <a-icon type="appstore"/>
            <span>任务配置</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </template>
    </a-page-header>
    <div class="page-title" style="margin-bottom: 16px">任务配置</div>
    <a-spin :spinning="taskList.spinning">
      <a-card>
        <a-tabs v-model="tabKey">
          <a-button  :size="$globalSize"  v-if="tabKey === 'flow'" type="primary" slot="tabBarExtraContent"
                    @click="$refs.createFlowModalRef.showModal('create')">
            创建流程
          </a-button>
          <a-button  :size="$globalSize"  v-else type="primary" slot="tabBarExtraContent" @click="$refs.createTaskModalRef.showModal()">
            创建任务
          </a-button>
          <a-tab-pane key="task" tab="任务配置">
            <a-table
                :columns="taskList.task_columns"
                :data-source="taskList.tableData"
                :pagination="false"
                row-key="id"
            >
<!--              <div slot="operation" slot-scope="text,record">-->
<!--                <a-popconfirm title="是否禁用该流程" @confirm="disableWorkFlow(record,'task')">-->
<!--                  <a-button  :size="$globalSize"  type="link">禁用</a-button>-->
<!--                </a-popconfirm>-->
<!--              </div>-->
              <div slot="status" slot-scope="text">
                {{ text == 1 ? '有效' : '无效' }}
              </div>
            </a-table>
            <my-pagination
                ref="myTaskPaginationRef"
                @change="getTaskList"
                :total="taskList.totalCount"
                style="padding-top: 20px"
            ></my-pagination>
          </a-tab-pane>
          <a-tab-pane key="flow" tab="工作流程">

            <a-table
                :columns="scheduleList.schedule_columns"
                :data-source="scheduleList.tableData"
                :pagination="false"
                row-key="id"
            >
              <div slot="operation" slot-scope="text,record">
                <a-button  :size="$globalSize"  type="link" @click="confSchedule(record)">配置流程</a-button>
                <a-button  :size="$globalSize"  type="link" @click="editSchedule(record)">编辑</a-button>
                <a-button  :size="$globalSize"  type="link" @click="scheduleIns(record)">当前实例</a-button>
                <a-popconfirm title="是否禁用该流程" v-if="!!record.status" @confirm="disableWorkFlow(record,'flow')">
                  <a-button  :size="$globalSize"  type="link">禁用</a-button>
                </a-popconfirm>
                <a-popconfirm title="是否启用该流程" v-else @confirm="enableWorkFlow(record)">
                  <a-button  :size="$globalSize"  type="link">启用</a-button>
                </a-popconfirm>
              </div>
              <div slot="status" slot-scope="text">
                {{ text === 1 ? '有效' : '无效' }}
              </div>
            </a-table>
            <my-pagination
                ref="myFlowPaginationRef"
                @change="getScheduleList"
                :total="scheduleList.totalCount"
                style="padding-top: 20px"
            ></my-pagination>


            <!-- style="background-color: #f5f6f6;position: relative" <my-process-design ref="processDesignRef"></my-process-design> -->
          </a-tab-pane>
          <!--          <a-button  :size="$globalSize"  slot="tabBarExtraContent" type="primary">-->
          <!--            配置任务-->
          <!--          </a-button>-->
        </a-tabs>
      </a-card>
    </a-spin>
    <work-flow-modal ref="createFlowModalRef" @refresh="getScheduleList"></work-flow-modal>
    <create-task-modal ref="createTaskModalRef" @refresh="getTaskList"></create-task-modal>
  </div>

</template>

<script>
const task_columns = [
  {
    title: '任务名称',
    dataIndex: 'job_name',
    key: 'job_name',
    width: 300,
    ellipsis: true,
    align: 'center'
  },
  {
    title: '任务类型',
    dataIndex: 'job_type',
    key: 'job_type',
    align: 'center'
  },
  {
    title: '执行线程',
    dataIndex: 'thread',
    key: 'thread',
    width: 600,

    ellipsis: true,
    align: 'center'
  },
  {
    title: '创建人',
    dataIndex: 'create_by',
    key: 'create_by',

    align: 'center'
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
    key: 'create_time',

    align: 'center'
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    align: 'center',
    scopedSlots: {customRender: "status"}
  },
  // {
  //   title: '操作',
  //   dataIndex: 'operation',
  //   key: 'operation',
  //   align: 'center',
  //   scopedSlots: {customRender: "operation"},
  // }

]

const schedule_columns = [
  {
    title: '调度ID',
    dataIndex: 'id',
    key: 'id',

    ellipsis: true,
    align: 'center'
  },
  {
    title: '调度名称',
    dataIndex: 'schedule_name',
    key: 'schedule_name',
    align: 'center'
  },
  {
    title: '调度周期',
    dataIndex: 'schedule_exp',
    key: 'schedule_exp',

    ellipsis: true,
    align: 'center'
  },
  {
    title: '触发时间',
    dataIndex: 'trigger_time',
    key: 'trigger_time',

    ellipsis: true,
    align: 'center'
  },
  {
    title: '创建人',
    dataIndex: 'create_by',
    key: 'create_by',

    align: 'center'
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
    key: 'create_time',

    align: 'center'
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    align: 'center',
    scopedSlots: {customRender: "status"}
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation',
    align: 'center',
    scopedSlots: {customRender: "operation"},
  }

]
import MyPagination from "@/components/MyPagination";
import myProcessDesign from "@/views/workflow/myProcessDesign.vue";
import workflow from "@/interface/pages/workflow/workflow";
import workFlowModal from "@/views/application/ai/components/workFlowModal";
import createTaskModal from "@/views/application/ai/components/createTaskModal";

export default {
  name: "StrategyTaskConfig",
  props: {},
  components: {
    MyPagination,
    myProcessDesign,
    workFlowModal,
    createTaskModal
  },
  data() {
    return {
      tabKey: 'task',

      taskList: {
        spinning: false,
        totalCount: 0,
        task_columns,
        tableData: []
      },
      scheduleList: {
        spinning: false,
        totalCount: 0,
        schedule_columns,
        tableData: []
      },

    }
  },
  methods: {
    // 获取任务列表
    async getTaskList() {
      this.taskList.spinning = true
      this.loading = true;
      var data = {
        ...this.$refs.myTaskPaginationRef.pagination
      };

      workflow.getJobinfoList(this, {params: data}).then(
          function (resp) {
            let res = resp.data;

            if (res.code == '200') {

              setTimeout(() => {
                this.taskList.tableData = res.data;
                this.taskList.totalCount = res.totalCount;
                this.taskList.spinning = false
              }, 700)
            } else {
              this.taskList.spinning = false
            }
          }.bind(this)
      ).catch(reason => {
        console.log(reason);
      })
    },
    // 获取工作流列表
    async getScheduleList() {
      this.scheduleList.spinning = true
      this.loading = true;
      var data = {
        ...this.$refs.myFlowPaginationRef.pagination
      };
      workflow.getScheduleList(this, {params: data}).then(
          function (resp) {
            let res = resp.data;

            if (res.code == '200') {

              setTimeout(() => {
                this.scheduleList.tableData = res.data;
                this.scheduleList.totalCount = res.totalCount;
                this.scheduleList.spinning = false
              }, 700)
            } else {
              this.scheduleList.spinning = false
            }
          }.bind(this)
      ).catch(reason => {
        console.log(reason);
      })
    },


    scheduleIns(task) {
      window.open('/authority/strategyTaskConfig/scheduleInstance?schedule_id=' + task.id + '', '_blank')
      //this.$router.push("/authority/strategyTaskConfig/scheduleInstance?schedule_id=" + task.id);
    },
    confSchedule(task) {
      window.open('/authority/strategyTaskConfig/configSchedule?schedule_id=' + task.id + '', '_blank')
      //this.$router.push("/authority/strategyTaskConfig/configSchedule?schedule_id=" + task.id);
    },
    editSchedule(task) {
      this.$refs.createFlowModalRef.showModal('edit', task)
    },

    async disableWorkFlow(task, type) {
      const data = type === 'flow' ? {schedule_id: task.id} : {}
      const {data: res} = type === 'flow' ? await workflow.disableWorkFlow(this, {data}) : ''
      try {
        if (res.code === '200') {
          this.$message.success('已禁用')
          this.getScheduleList()
        } else {
          this.$message.error(res.message)
        }
      } catch (e) {
        console.log(e)
      }
    },
    async enableWorkFlow(task) {
      const data = {schedule_id: task.id}
      const {data: res} = await workflow.enableWorkFlow(this, {data})
      try {
        if (res.code === '200') {
          this.$message.success('已启用')
          this.getScheduleList()
        } else {
          this.$message.error(res.message)
        }
      } catch (e) {
        console.log(e)
      }
    }
  },
  watch: {},
  computed: {}
}
</script>

<style scoped lang="less">

</style>